import Vue from 'vue';
import VueI18n from 'vue-i18n';
import zh from './i18n/zh.json';
import en from './i18n/en.json';

Vue.use(VueI18n);

const messages = { zh, en };
const saved = localStorage.getItem('lan');

export default new VueI18n({
  locale: messages[saved] ? saved : 'zh',
  fallbackLocale: 'zh',
  messages,
});
